import React from "react";
import tocbot from "tocbot";

export default function Toc({ refresh, ...style }) {
  React.useEffect(() => {
    tocbot.init({
      tocSelector: ".toc",
      contentSelector: ".post",
      headingSelector: "h1, h2, h3",
      hasInnerContainers: true,
      headingsOffset: 100,
      scrollSmoothOffset: -100,
    });

    // window.setTimeout(refeshToc, 1000);
    // tocbot.refresh();
    return () => {
      tocbot.destroy();
    };
  });
  React.useEffect(() => {
    function refeshToc() {
      tocbot.refresh();
    }
    window.setTimeout(refeshToc, 1000);

    return () => {
      window.clearTimeout(refeshToc);
    };
  }, [refresh]);

  return (
    <>
      <div className="toc" {...style} />
      <style jsx global>{`
        .toc {
          background-color: var(--content-bg-primary);
          border: 1px solid var(--content-border);
          border-radius: 0.25rem;
          padding: 1rem;
          font-size: 0.875rem;
        }

        .toc-list .toc-list {
          padding-left: 1rem;
          padding-top: 0.5rem;
        }

        .toc-list-item {
          padding-bottom: 0.5rem;
        }

        .toc-list-item:last-child {
          padding-bottom: 0;
        }

        .toc-link {
          color: var(--text-secondary);
        }

        .is-active-link {
          color: var(--text-primary);
          font-weight: 700;
        }
        .is-collapsed {
          max-height: 1000px !important;
          overflow: hidden;
          transition: all 300ms ease-in-out;
        }
      `}</style>
    </>
  );
}
